import { FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react'
import React from 'react'

const FormSelect = ({ error, isRequired, onChange, id, value, label, placeholder, options, ...rest }) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={Boolean(error)} {...rest}>
      <FormLabel>{label}</FormLabel>
      <Select
        h="48px"
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      >
        {options.map(option => (
          <option value={option} key={option}>{option}</option>
        ))}
      </Select>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}

export default FormSelect
